import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommunicationAnalyticsState } from './models/communication-analytics-state.models';

export const selectCommunicationAnalyticsState = createFeatureSelector<CommunicationAnalyticsState>('communicationAnalytics');

export const selectCommunicationOverview = createSelector(
  selectCommunicationAnalyticsState,
  (state: CommunicationAnalyticsState) => state.overview
);

export const selectCommunicationTrend = createSelector(
  selectCommunicationAnalyticsState,
  (state: CommunicationAnalyticsState) => state.trend
);

export const selectCommunicationTimePattern = createSelector(
  selectCommunicationAnalyticsState,
  (state: CommunicationAnalyticsState) => state.timePattern
);

export const selectCommunicationLoading = createSelector(
  selectCommunicationAnalyticsState,
  (state: CommunicationAnalyticsState) => state.loading
);

export const selectCommunicationError = createSelector(
  selectCommunicationAnalyticsState,
  (state: CommunicationAnalyticsState) => state.error
);
